import React from 'react';

interface StorySpinnerProps {
  size?: 'small' | 'medium' | 'large';
  showProgressBar?: boolean;
  className?: string;
}

const StorySpinner: React.FC<StorySpinnerProps> = ({ 
  size = 'large', 
  showProgressBar = false,
  className = ''
}) => {
  const sizeClasses = {
    small: 'h-8 w-8',
    medium: 'h-12 w-12', 
    large: 'h-16 w-16'
  };

  const containerClasses = {
    small: 'p-4',
    medium: 'p-6',
    large: 'p-8'
  };

  return (
    <div className={`min-h-screen bg-gray-50 flex items-center justify-center ${className}`}>
      <div className={`bg-white rounded-lg shadow-lg ${containerClasses[size]} max-w-md mx-auto`}>
        <div className="text-center" role="status" aria-live="polite">
          <div className="text-gray-400 mb-4">
            <div 
              className={`animate-spin rounded-full ${sizeClasses[size]} border-b-2 border-purple-600 mx-auto`}
            ></div>
          </div>
          <h2 className="text-xl font-semibold text-gray-900 mb-2">We're crafting your story</h2>
          <p className="text-gray-600 mb-6">This will just take a moment...</p>
          <span className="sr-only">Generating story, please wait...</span>
          {showProgressBar && (
            <div className="bg-gradient-to-r from-purple-600 to-blue-600 h-1 rounded-full"></div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StorySpinner;
